import {Outlet} from 'react-router'

import {useFeaturesMenu} from './welcomeFlow/useFeaturesMenu'
import {WelcomeModal} from './welcomeFlow/WelcomeModal'

export const WelcomeFlow = () => {
  const {isFeatureMenuNotFound} = useFeaturesMenu()

  return isFeatureMenuNotFound ? <WelcomeModal /> : <Outlet />
}
